import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { unlockCardForNotPotentialFraud } from '@src/api'
import { DefaultApiUnlockCardForNotPotentialFraudRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'
import { CustomError } from '@src/types'

export const useUnlockCardForNotPotentialFraud = () => {
  const { axiosInstance } = useAxios()

  return useMutation<
    unknown,
    AxiosResponse<CustomError>,
    DefaultApiUnlockCardForNotPotentialFraudRequest
  >({
    mutationFn: (params: DefaultApiUnlockCardForNotPotentialFraudRequest) =>
      unlockCardForNotPotentialFraud(axiosInstance, params),
  })
}
